// src/admin/ui/Card.jsx
export function Card({ title, subtitle, right, children }) {
  return (
    <section className="card">
      {(title || right) && (
        <header className="card__head">
          <div>
            {title && <h2 className="card__title">{title}</h2>}
            {subtitle && <div className="card__sub">{subtitle}</div>}
          </div>
          {right && <div className="card__right">{right}</div>}
        </header>
      )}
      <div className="card__body">{children}</div>
    </section>
  );
}
